import { useQuestionnaireFormContext } from "src/components/QuestionnaireForm/context/useQuestionnaireForm";
import { QuestionnaireUpdateFormBase } from "./QuestionnaireUpdateFormBase";
import { useTranslation } from "react-i18next";
import { QuestionnaireUpdateFormWithPages } from "./QuestionnaireUpdateFormWithPages";
import { StalePostRecalculateModal } from "src/components/QuestionnairesList/StalePostRecalculateModal";

export const QuestionnaireForm = () => {
    const { ssqVersion, isSsqVersionLoading, post } = useQuestionnaireFormContext();
    const { t } = useTranslation();

    if (isSsqVersionLoading) {
        return (
            <>
                <StalePostRecalculateModal post={post} />
                <QuestionnaireUpdateFormBase isLoading={true} />
            </>
        );
    }

    if (!ssqVersion) return t("questionnaire.not_found", "The questionnaire has not been found");

    return (
        <>
            <StalePostRecalculateModal post={post} />
            <QuestionnaireUpdateFormWithPages />
        </>
    );
};
